module.exports = __webpack_public_path__ + "media/images/brand/img-mantle-sp-f2dce8e39914a840c6af7a8587e34190.svg";